<template>
  <div class="words">
    <template v-for="word of words">
      <button 
        v-if="!word.guessed && !word.error"
        :disabled="word.selected"
        :class="['word', {
          loading: word.loading,
          focused: word.id === focusWord.id,
          help: !word.guessed && useHelp,
        }]"
        @click="$emit('select', word)"
        v-text="word.value"
      />
    </template>
  </div>
</template>


<script>
export default {
  name: 'UnusedWord',

  props: {
    useHelp: Boolean,
    words: {
      type: Object,
      required: true,
    },
    focusWord: {
      default: () => ({}),
    },
  },
};
</script>


<style lang="scss" scoped>
.words {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  user-select: none;
  gap: 12px;

  .word {
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: var(--color-primary);
    padding: 0 12px;
    font-size: 20px;
    height: 28px;
    font-family: Arial;
    font-weight: bold;
    line-height: 1;
    color: #D9F855;

    &.focused {
      background-color: #C7B2F7;
      color: #4D43C6;
    }

    &[disabled] {
      opacity: .5;
      cursor: not-allowed;
    }
  } 
}
</style>